/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { publicationStatus } from './enums';
import { PublicationInfoByZone } from './publicationInfoByZone';

export class Publication extends DaoModel {
  constructor(guid, generation_status, modification_date, publication_info_by_zone) {
    super(guid);
    this.generation_status = generation_status || publicationStatus.DEFINED;
    this.modification_date = modification_date ? new Date(modification_date) : '-';
    this.publication_info_by_zone = publication_info_by_zone;
  }

  static toInstance(props = {}) {
    const publication_info_by_zone = props.publication_info_by_zone ? PublicationInfoByZone.toInstanceList(props.publication_info_by_zone) : [];
    return new Publication(props.guid, props.generation_status, props.modification_date, publication_info_by_zone);
  }

  serialize() {
    return {
      ...super.serialize(),
      generation_status: this.generation_status,
      modification_date: this.modification_date,
      publication_info_by_zone: this.publication_info_by_zone.map((info) => info.serialize()),
    };
  }
}
